import React from "react";
import { Link } from 'react-router-dom';
import Datetime from "react-datetime";
import moment from "moment";
import { Form, Field } from "react-final-form";
import { Query, graphql, compose } from "react-apollo";

// graphql
import clienti from "graphql/queries/clienti";
import agenti from "graphql/queries/agenti";
import agentiSegretarie from "graphql/queries/agentiSegretarie";
import campagne from "graphql/queries/campagne";
import offerte from "graphql/queries/offerte";
import createAssenza from "graphql/mutations/createAssenza";
import createAzione from "graphql/mutations/createAzione";
import updateAssenza from "graphql/mutations/updateAssenza";
import updateAzione from "graphql/mutations/updateAzione";
import deleteAssenza from "graphql/mutations/deleteAssenza";
import deleteAzione from "graphql/mutations/deleteAzione";
// graphql per refetchQueries
import appuntamentiPerStato from "graphql/queries/appuntamentiPerStato";
import utente from "graphql/queries/utente";
import cliente from "graphql/queries/cliente";
import me from "graphql/queries/me";
import assenze from "graphql/queries/assenze";
import azioni from "graphql/queries/azioni";

// material-ui components
import withStyles from "material-ui/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import TextField from "components/TextField/TextField";
import AutocompleteField from "components/AutocompleteField/AutocompleteField";

// material-ui
import Modal from "material-ui/Modal";
import FormControl from "material-ui/Form/FormControl";
import InputLabel from "material-ui/Input/InputLabel";
import Button from "material-ui/Button";
import IconButton from "material-ui/IconButton";

// material-ui icons
import Delete from "material-ui-icons/Delete";
import OpenInNew from "material-ui-icons/OpenInNew";

// style
import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle.jsx";

class CalendarModalForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      clientiSearchQuery: "",
      campagneSearchQuery: "",
      offerteSearchQuery: "",
    };
  }

  handleChangeCampagneSearchQuery = (campagneSearchQuery) => {
    //console.log('q', campagneSearchQuery)
    this.setState({
      campagneSearchQuery,
    });
  };

  handleChangeOfferteSearchQuery = (offerteSearchQuery) => {
    //console.log('q', offerteSearchQuery)
    this.setState({
      offerteSearchQuery,
    });
  };

  handleChangeClientiSearchQuery = (clientiSearchQuery) => {
    //console.log('q', clientiSearchQuery)
    this.setState({
      clientiSearchQuery,
    });
  };

  timelineActionTypeId(tipoAzione) {
    switch (tipoAzione.toLowerCase()) {
      case "appuntamento":
        return 1;
      case "telefonata in":
        return 2;
      case "telefonata out":
        return 3;
      case "email in":
        return 4;
      case "email out":
        return 5;
      case "form":
        return 6;
      case "promemoria":
        return 8;
      case "nota":
        return 12;
      case "whatsapp in":
        return 13;
      case "whatsapp out":
        return 14;
      case "proposta acquisto":
        return 15;
      case "preliminare":
        return 16;
      default:
        return null;
    }
  }

  deleteEvent = (eventId, tipoEvento, agenteId) => (event) => {
    const { eventsType, onCloseModal, onSetErrorMessage } = this.props;

    const startOfMonth = moment()
      .startOf("month")
      .subtract(7, "days")
      .format("YYYY-MM-DD");
    const endOfMonth = moment()
      .endOf("month")
      .add(7, "days")
      .format("YYYY-MM-DD");

    const startOfDay = moment(this.state.dataCorrente)
      .startOf("day")
      .subtract(1, "days")
      .format("YYYY-MM-DD");
    const endOfDay = moment(this.state.dataCorrente)
      .endOf("day")
      .add(1, "days")
      .format("YYYY-MM-DD");

    event.preventDefault();

    // CALENDARIO
    if (eventsType === "calendar" || eventsType === "calendar-agent-detail") {
      if (
        tipoEvento.toLowerCase() === "assenza-occupato" ||
        tipoEvento.toLowerCase() === "assenza-fuori-sede"
      ) {
        // ELIMINA ASSENZA
        this.props
          .deleteAssenza({
            variables: {
              id: eventId,
            },
            refetchQueries: [
              {
                query: me,
              },
              {
                query: utente,
                variables: {
                  where: {
                    id: agenteId,
                  },
                  appuntamentiWhere: {
                    OR: [
                      {
                        appuntamentoDaDataOra_gte: startOfMonth,
                        appuntamentoDaDataOra_lte: endOfMonth,
                      },
                      {
                        appuntamentoADataOra_gte: startOfMonth,
                        appuntamentoADataOra_lte: endOfMonth,
                      },
                      {
                        appuntamentoDaDataOra_lte: startOfMonth,
                        appuntamentoADataOra_gte: endOfMonth,
                      },
                    ],
                  },
                  assenzeWhere: {
                    OR: [
                      {
                        daDataOra_gte: startOfMonth,
                        daDataOra_lte: endOfMonth,
                      },
                      {
                        aDataOra_gte: startOfMonth,
                        aDataOra_lte: endOfMonth,
                      },
                      {
                        daDataOra_lte: startOfMonth,
                        aDataOra_gte: endOfMonth,
                      },
                    ],
                  },
                },
              },
              {
                query: assenze,
                variables: {
                  limit: 200,
                  where: {
                    OR: [
                      {
                        daDataOra_gte: startOfDay,
                        daDataOra_lte: endOfDay,
                      },
                      {
                        aDataOra_gte: startOfDay,
                        aDataOra_lte: endOfDay,
                      },
                      {
                        daDataOra_lte: startOfDay,
                        aDataOra_gte: endOfDay,
                      },
                    ],
                  },
                },
              },
            ],
          })
          .then(() => {
            //console.log('eliminato')
            onCloseModal();
          })
          .catch((error) => {
            console.log(error.message);
            onSetErrorMessage(error.message);
          });
      } else if (tipoEvento.toLowerCase() === "appuntamento") {
        // ELIMINA APPUNTAMENTO
        this.props
          .deleteAzione({
            variables: {
              id: eventId,
            },
            refetchQueries: [
              {
                query: me,
              },
              {
                query: utente,
                variables: {
                  where: {
                    id: agenteId,
                  },
                  appuntamentiWhere: {
                    OR: [
                      {
                        appuntamentoDaDataOra_gte: startOfMonth,
                        appuntamentoDaDataOra_lte: endOfMonth,
                      },
                      {
                        appuntamentoADataOra_gte: startOfMonth,
                        appuntamentoADataOra_lte: endOfMonth,
                      },
                      {
                        appuntamentoDaDataOra_lte: startOfMonth,
                        appuntamentoADataOra_gte: endOfMonth,
                      },
                    ],
                  },
                  assenzeWhere: {
                    OR: [
                      {
                        daDataOra_gte: startOfMonth,
                        daDataOra_lte: endOfMonth,
                      },
                      {
                        aDataOra_gte: startOfMonth,
                        aDataOra_lte: endOfMonth,
                      },
                      {
                        daDataOra_lte: startOfMonth,
                        aDataOra_gte: endOfMonth,
                      },
                    ],
                  },
                },
              },
              {
                query: azioni,
                variables: {
                  limit: 200,
                  where: {
                    AND: [
                      {
                        tipoAzioneId: 1,
                      },
                      {
                        OR: [
                          {
                            appuntamentoDaDataOra_gte: startOfDay,
                            appuntamentoDaDataOra_lte: endOfDay,
                          },
                          {
                            appuntamentoADataOra_gte: startOfDay,
                            appuntamentoADataOra_lte: endOfDay,
                          },
                          {
                            appuntamentoDaDataOra_lte: startOfDay,
                            appuntamentoADataOra_gte: endOfDay,
                          },
                        ],
                      },
                    ],
                  },
                },
              },
            ],
          })
          .then(() => {
            //console.log('eliminato')
            onCloseModal();
          })
          .catch((error) => {
            console.log(error.message);
            onSetErrorMessage(error.message);
          });
      }

      // TIMELINE E HOME SEGRETARIA
    } else if (eventsType === "timeline" || eventsType === "home-segretaria") {
      // ELIMINA AZIONE
      this.props
        .deleteAzione({
          variables: {
            id: eventId,
          },
          refetchQueries: ["cliente", "azioni"],
        })
        .then(() => {
          console.log("eliminato");
          onCloseModal();
        })
        .catch((error) => {
          console.log(error.message);
          onSetErrorMessage(error.message);
        });
    }
  };

  onSubmit = (values) => {
    const {
      eventsType,
      isNewEvent,
      onCloseModal,
      onSetErrorMessage,
      isAgente,
      agenteId,
    } = this.props;

    const startOfMonth = moment()
      .startOf("month")
      .subtract(7, "days")
      .format("YYYY-MM-DD");
    const endOfMonth = moment()
      .endOf("month")
      .add(7, "days")
      .format("YYYY-MM-DD");

    const startOfDay = moment(this.state.dataCorrente)
      .startOf("day")
      .subtract(1, "days")
      .format("YYYY-MM-DD");
    const endOfDay = moment(this.state.dataCorrente)
      .endOf("day")
      .add(1, "days")
      .format("YYYY-MM-DD");

    // CALENDARIO DETT. AGENTE - ADMIN E SEGRETARIE
    if (eventsType === "calendar-agent-detail") {
      // EVENTO ESISTENTE
      if (!isNewEvent) {
        if (
          values.tipoEvento.toLowerCase() === "assenza-occupato" ||
          values.tipoEvento.toLowerCase() === "assenza-fuori-sede"
        ) {
          // AGGIORNA ASSENZA
          this.props
            .updateAssenza({
              variables: {
                id: values.id,
                assenza: {
                  daDataOra: moment(values.start).format("YYYY-MM-DD HH:mm"),
                  aDataOra: moment(values.end).format("YYYY-MM-DD HH:mm"),
                  descrizione: values.descrizione,
                  flagOccupato:
                    values.tipoEvento.toLowerCase() === "assenza-occupato",
                },
              },
              refetchQueries: ["utente"],
            })
            .then(({ data }) => {
              //console.log(data)
              onCloseModal();
            })
            .catch((error) => {
              console.log(error.message);
              onSetErrorMessage(error.message);
            });
        } else if (values.tipoEvento.toLowerCase() === "appuntamento") {
          // AGGIORNA APPUNTAMENTO
          this.props
            .updateAzione({
              variables: {
                id: values.id,
                azione: {
                  clienteId: values.clienteId,
                  dataOra: moment().format("YYYY-MM-DD HH:mm"), //DA CONTROLLARE CHE NON LA IMPOSTI GIA' IL SERVER
                  tipoAzioneId: 1, //appuntamento
                  appuntamentoAgenteId: values.agenteId,
                  appuntamentoDaDataOra: moment(values.start).format(
                    "YYYY-MM-DD HH:mm"
                  ),
                  appuntamentoADataOra: moment(values.end).format(
                    "YYYY-MM-DD HH:mm"
                  ),
                  appuntamentoLuogo: values.luogo,
                  appuntamentoStato: values.stato,
                  appuntamentoOrigine: values.appuntamentoOrigine,
                  descrizione: values.descrizione,
                },
              },
              refetchQueries: ["utente"],
            })
            .then(({ data }) => {
              console.log(data);
              onCloseModal();
            })
            .catch((error) => {
              console.log(error.message);
              onSetErrorMessage(error.message);
            });
        }
        // NUOVO EVENTO
      } else {
        if (
          values.tipoEvento.toLowerCase() === "assenza-occupato" ||
          values.tipoEvento.toLowerCase() === "assenza-fuori-sede"
        ) {
          // CREA ASSENZA
          this.props
            .createAssenza({
              variables: {
                assenza: {
                  utenteId: values.agenteId,
                  daDataOra: moment(values.start).format("YYYY-MM-DD HH:mm"),
                  aDataOra: moment(values.end).format("YYYY-MM-DD HH:mm"),
                  descrizione: values.descrizione,
                  flagOccupato:
                    values.tipoEvento.toLowerCase() === "assenza-occupato",
                },
              },
              refetchQueries: ["utente"],
            })
            .then(({ data }) => {
              //console.log(data)
              onCloseModal();
            })
            .catch((error) => {
              console.log(error.message);
              onSetErrorMessage(error.message);
            });
        } else if (values.tipoEvento.toLowerCase() === "appuntamento") {
          // CREA APPUNTAMENTO
          this.props
            .createAzione({
              variables: {
                azione: {
                  clienteId: values.clienteId,
                  dataOra: moment().format("YYYY-MM-DD HH:mm"), //DA CONTROLLARE CHE NON LA IMPOSTI GIA' IL SERVER
                  tipoAzioneId: 1, //appuntamento
                  appuntamentoAgenteId: values.agenteId,
                  appuntamentoDaDataOra: moment(values.start).format(
                    "YYYY-MM-DD HH:mm"
                  ),
                  appuntamentoADataOra: moment(values.end).format(
                    "YYYY-MM-DD HH:mm"
                  ),
                  appuntamentoLuogo: values.luogo,
                  appuntamentoStato: values.stato,
                  appuntamentoOrigine: values.appuntamentoOrigine,
                  descrizione: values.descrizione,
                },
              },
              refetchQueries: ["utente"],
            })
            .then(({ data }) => {
              //console.log(data)
              onCloseModal();
            })
            .catch((error) => {
              console.log(error.message);
              onSetErrorMessage(error.message);
            });
        }
      }
    }

    // TIMELINE - ADMIN, SEGRETARIE E AGENTI
    else if (eventsType === "timeline") {
      //AZIONE ESISTENTE
      if (!isNewEvent) {
        this.props
          .updateAzione({
            variables: {
              id: values.id,
              azione: {
                clienteId: values.clienteId,
                dataOra:
                  values.tipoEvento === "appuntamento"
                    ? moment().format("YYYY-MM-DD HH:mm")
                    : moment(values.dataOra).format("YYYY-MM-DD HH:mm"),
                tipoAzioneId: this.timelineActionTypeId(values.tipoEvento),
                campagnaId: values.campagnaId,
                offertaId: values.offertaId,
                appuntamentoAgenteId:
                  values.tipoEvento === "appuntamento" ||
                  values.tipoEvento === "preliminare" ||
                  values.tipoEvento === "proposta acquisto"
                    ? values.agenteId
                    : null, // CONTROLLARE!!!
                appuntamentoDaDataOra:
                  values.tipoEvento === "appuntamento"
                    ? moment(values.start).format("YYYY-MM-DD HH:mm")
                    : null,
                appuntamentoADataOra:
                  values.tipoEvento === "appuntamento"
                    ? moment(values.end).format("YYYY-MM-DD HH:mm")
                    : null,
                appuntamentoLuogo:
                  values.tipoEvento === "appuntamento" ? values.luogo : null,
                appuntamentoStato:
                  values.tipoEvento === "appuntamento" ? values.stato : null,
                promemoriaUtenteId:
                  values.tipoEvento === "promemoria"
                    ? values.promemoriaUtenteId
                    : null,
                promemoriaDataOra:
                  values.tipoEvento === "promemoria"
                    ? moment(values.promemoriaDataOra).format(
                        "YYYY-MM-DD HH:mm"
                      )
                    : null,
                promemoriaDismesso: false,
                nonRisposto:
                  values.tipoEvento === "telefonata out"
                    ? // || values.tipoEvento === 'email out' ||
                      // values.tipoEvento === 'whatsapp out'
                      values.nonRisposto
                    : false,
                // descrizione: values.descrizione,
                appuntamentoOrigine:
                  values.tipoEvento === "appuntamento"
                    ? values.appuntamentoOrigine
                    : null,
                descrizione: values.nonRisposto
                  ? "Non ha risposto"
                  : values.descrizione,
              },
            },
            refetchQueries: ["cliente"],
          })
          .then(({ data }) => {
            //console.log(data)
            onCloseModal();
          })
          .catch((error) => {
            console.log(error.message);
            onSetErrorMessage(error.message);
          });
        // NUOVA AZIONE
      } else {
        //console.log('crea', values.appuntamentoOrigine)
        this.props
          .createAzione({
            variables: {
              azione: {
                clienteId: values.clienteId,
                dataOra:
                  values.tipoEvento === "appuntamento"
                    ? moment().format("YYYY-MM-DD HH:mm")
                    : moment(values.dataOra).format("YYYY-MM-DD HH:mm"),
                tipoAzioneId: this.timelineActionTypeId(values.tipoEvento),
                campagnaId: values.campagnaId,
                offertaId: values.offertaId,
                appuntamentoAgenteId:
                  values.tipoEvento === "appuntamento" ||
                  values.tipoEvento === "preliminare" ||
                  values.tipoEvento === "proposta acquisto"
                    ? values.agenteId
                    : null, // CONTROLLARE!!!
                appuntamentoDaDataOra:
                  values.tipoEvento === "appuntamento"
                    ? moment(values.start).format("YYYY-MM-DD HH:mm")
                    : null,
                appuntamentoADataOra:
                  values.tipoEvento === "appuntamento"
                    ? moment(values.end).format("YYYY-MM-DD HH:mm")
                    : null,
                appuntamentoLuogo:
                  values.tipoEvento === "appuntamento" ? values.luogo : null,
                appuntamentoStato:
                  values.tipoEvento === "appuntamento" ? values.stato : null,
                promemoriaUtenteId:
                  values.tipoEvento === "promemoria"
                    ? values.promemoriaUtenteId
                    : null,
                promemoriaDataOra:
                  values.tipoEvento === "promemoria"
                    ? moment(values.promemoriaDataOra).format(
                        "YYYY-MM-DD HH:mm"
                      )
                    : null,
                promemoriaDismesso: false,
                nonRisposto:
                  values.tipoEvento === "telefonata out"
                    ? // ||
                      // values.tipoEvento === 'email out' ||
                      // values.tipoEvento === 'whatsapp out'
                      values.nonRisposto
                    : false,
                // descrizione: values.descrizione,
                appuntamentoOrigine:
                  values.tipoEvento === "appuntamento"
                    ? values.appuntamentoOrigine
                    : null,
                descrizione: values.nonRisposto
                  ? "Non ha risposto"
                  : values.descrizione,
              },
            },
            refetchQueries: ["cliente"],
          })
          .then(({ data }) => {
            //console.log(data)
            onCloseModal();
          })
          .catch((error) => {
            console.log(error.message);
            onSetErrorMessage(error.message);
          });
      }
    }

    // CALENDARIO E TIMELINE - TIMELINE SOLO AGENTE
    else if (
      eventsType === "calendar" ||
      (eventsType === "timeline" && !!isAgente)
    ) {
      // EVENTO ESISTENTE
      if (!isNewEvent) {
        if (
          values.tipoEvento.toLowerCase() === "assenza-occupato" ||
          values.tipoEvento.toLowerCase() === "assenza-fuori-sede"
        ) {
          // AGGIORNA ASSENZA
          this.props
            .updateAssenza({
              variables: {
                id: values.id,
                assenza: {
                  daDataOra: moment(values.start).format("YYYY-MM-DD HH:mm"),
                  aDataOra: moment(values.end).format("YYYY-MM-DD HH:mm"),
                  utenteId: values.agenteId,
                  descrizione: values.descrizione,
                  flagOccupato:
                    values.tipoEvento.toLowerCase() === "assenza-occupato",
                },
              },
              refetchQueries: [
                {
                  query: utente,
                  variables: {
                    where: {
                      id: values.agenteId,
                    },
                    appuntamentiWhere: {
                      OR: [
                        {
                          appuntamentoDaDataOra_gte: startOfMonth,
                          appuntamentoDaDataOra_lte: endOfMonth,
                        },
                        {
                          appuntamentoADataOra_gte: startOfMonth,
                          appuntamentoADataOra_lte: endOfMonth,
                        },
                        {
                          appuntamentoDaDataOra_lte: startOfMonth,
                          appuntamentoADataOra_gte: endOfMonth,
                        },
                      ],
                    },
                    assenzeWhere: {
                      OR: [
                        {
                          daDataOra_gte: startOfMonth,
                          daDataOra_lte: endOfMonth,
                        },
                        {
                          aDataOra_gte: startOfMonth,
                          aDataOra_lte: endOfMonth,
                        },
                        {
                          daDataOra_lte: startOfMonth,
                          aDataOra_gte: endOfMonth,
                        },
                      ],
                    },
                  },
                },
                {
                  query: assenze,
                  variables: {
                    limit: 200,
                    where: {
                      OR: [
                        {
                          daDataOra_gte: startOfDay,
                          daDataOra_lte: endOfDay,
                        },
                        {
                          aDataOra_gte: startOfDay,
                          aDataOra_lte: endOfDay,
                        },
                        {
                          daDataOra_lte: startOfDay,
                          aDataOra_gte: endOfDay,
                        },
                      ],
                    },
                  },
                },
              ],
            })
            .then(({ data }) => {
              //console.log(data)
              onCloseModal();
            })
            .catch((error) => {
              console.log(error.message);
              onSetErrorMessage(error.message);
            });
        } else if (values.tipoEvento.toLowerCase() === "appuntamento") {
          // AGGIORNA APPUNTAMENTO
          this.props
            .updateAzione({
              variables: {
                id: values.id,
                azione: {
                  clienteId: values.clienteId,
                  utenteId: values.agenteId,
                  dataOra: moment().format("YYYY-MM-DD HH:mm"), //DA CONTROLLARE CHE NON LA IMPOSTI GIA' IL SERVER
                  tipoAzioneId: 1, //appuntamento
                  appuntamentoAgenteId: values.agenteId,
                  appuntamentoDaDataOra: moment(values.start).format(
                    "YYYY-MM-DD HH:mm"
                  ),
                  appuntamentoADataOra: moment(values.end).format(
                    "YYYY-MM-DD HH:mm"
                  ),
                  appuntamentoLuogo: values.luogo,
                  appuntamentoStato: values.stato,
                  appuntamentoOrigine: values.appuntamentoOrigine,
                  descrizione: values.descrizione,
                },
              },
              // --->>>> MODIFICARE QUI!!!!
              refetchQueries: [
                {
                  query: cliente,
                  variables: {
                    where: {
                      id: values.clienteId,
                    },
                  },
                },
                {
                  query: utente,
                  variables: {
                    where: {
                      id: agenteId,
                    },
                    appuntamentiWhere: {
                      OR: [
                        {
                          appuntamentoDaDataOra_gte: startOfMonth,
                          appuntamentoDaDataOra_lte: endOfMonth,
                        },
                        {
                          appuntamentoADataOra_gte: startOfMonth,
                          appuntamentoADataOra_lte: endOfMonth,
                        },
                        {
                          appuntamentoDaDataOra_lte: startOfMonth,
                          appuntamentoADataOra_gte: endOfMonth,
                        },
                      ],
                    },
                    assenzeWhere: {
                      OR: [
                        {
                          daDataOra_gte: startOfMonth,
                          daDataOra_lte: endOfMonth,
                        },
                        {
                          aDataOra_gte: startOfMonth,
                          aDataOra_lte: endOfMonth,
                        },
                        {
                          daDataOra_lte: startOfMonth,
                          aDataOra_gte: endOfMonth,
                        },
                      ],
                    },
                  },
                },
                {
                  query: azioni,
                  variables: {
                    limit: 200,
                    where: {
                      AND: [
                        {
                          tipoAzioneId: 1,
                        },
                        {
                          OR: [
                            {
                              appuntamentoDaDataOra_gte: startOfDay,
                              appuntamentoDaDataOra_lte: endOfDay,
                            },
                            {
                              appuntamentoADataOra_gte: startOfDay,
                              appuntamentoADataOra_lte: endOfDay,
                            },
                            {
                              appuntamentoDaDataOra_lte: startOfDay,
                              appuntamentoADataOra_gte: endOfDay,
                            },
                          ],
                        },
                      ],
                    },
                  },
                },
              ],
            })
            .then(({ data }) => {
              //console.log(data)
              onCloseModal();
            })
            .catch((error) => {
              console.log(error.message);
              onSetErrorMessage(error.message);
            });
        }
        // NUOVO EVENTO
      } else {
        if (
          values.tipoEvento.toLowerCase() === "assenza-occupato" ||
          values.tipoEvento.toLowerCase() === "assenza-fuori-sede"
        ) {
          // CREA ASSENZA
          this.props
            .createAssenza({
              variables: {
                assenza: {
                  daDataOra: moment(values.start).format("YYYY-MM-DD HH:mm"),
                  aDataOra: moment(values.end).format("YYYY-MM-DD HH:mm"),
                  utenteId: values.agenteId,
                  descrizione: values.descrizione,
                  flagOccupato:
                    values.tipoEvento.toLowerCase() === "assenza-occupato",
                },
              },
              refetchQueries: [
                {
                  query: utente,
                  variables: {
                    where: {
                      id: values.agenteId,
                    },
                    appuntamentiWhere: {
                      OR: [
                        {
                          appuntamentoDaDataOra_gte: startOfMonth,
                          appuntamentoDaDataOra_lte: endOfMonth,
                        },
                        {
                          appuntamentoADataOra_gte: startOfMonth,
                          appuntamentoADataOra_lte: endOfMonth,
                        },
                        {
                          appuntamentoDaDataOra_lte: startOfMonth,
                          appuntamentoADataOra_gte: endOfMonth,
                        },
                      ],
                    },
                    assenzeWhere: {
                      OR: [
                        {
                          daDataOra_gte: startOfMonth,
                          daDataOra_lte: endOfMonth,
                        },
                        {
                          aDataOra_gte: startOfMonth,
                          aDataOra_lte: endOfMonth,
                        },
                        {
                          daDataOra_lte: startOfMonth,
                          aDataOra_gte: endOfMonth,
                        },
                      ],
                    },
                  },
                },
                {
                  query: assenze,
                  variables: {
                    limit: 200,
                    where: {
                      OR: [
                        {
                          daDataOra_gte: startOfDay,
                          daDataOra_lte: endOfDay,
                        },
                        {
                          aDataOra_gte: startOfDay,
                          aDataOra_lte: endOfDay,
                        },
                        {
                          daDataOra_lte: startOfDay,
                          aDataOra_gte: endOfDay,
                        },
                      ],
                    },
                  },
                },
              ],
            })
            .then(({ data }) => {
              //console.log(data)
              onCloseModal();
            })
            .catch((error) => {
              console.log(error.message);
              onSetErrorMessage(error.message);
            });
        } else if (values.tipoEvento.toLowerCase() === "appuntamento") {
          // CREA APPUNTAMENTO
          this.props
            .createAzione({
              variables: {
                azione: {
                  clienteId: values.clienteId,
                  utenteId: values.agenteId,
                  dataOra: moment().format("YYYY-MM-DD HH:mm"), //DA CONTROLLARE CHE NON LA IMPOSTI GIA' IL SERVER
                  tipoAzioneId: 1, //appuntamento
                  appuntamentoAgenteId: values.agenteId,
                  appuntamentoDaDataOra: moment(values.start).format(
                    "YYYY-MM-DD HH:mm"
                  ),
                  appuntamentoADataOra: moment(values.end).format(
                    "YYYY-MM-DD HH:mm"
                  ),
                  appuntamentoLuogo: values.luogo,
                  appuntamentoStato: values.stato,
                  appuntamentoOrigine: values.appuntamentoOrigine,
                  descrizione: values.descrizione,
                },
              },
              refetchQueries: [
                {
                  query: cliente,
                  variables: {
                    where: {
                      id: values.clienteId,
                    },
                  },
                },
                {
                  query: utente,
                  variables: {
                    where: {
                      id: values.agenteId,
                    },
                    appuntamentiWhere: {
                      OR: [
                        {
                          appuntamentoDaDataOra_gte: startOfMonth,
                          appuntamentoDaDataOra_lte: endOfMonth,
                        },
                        {
                          appuntamentoADataOra_gte: startOfMonth,
                          appuntamentoADataOra_lte: endOfMonth,
                        },
                        {
                          appuntamentoDaDataOra_lte: startOfMonth,
                          appuntamentoADataOra_gte: endOfMonth,
                        },
                      ],
                    },
                    assenzeWhere: {
                      OR: [
                        {
                          daDataOra_gte: startOfMonth,
                          daDataOra_lte: endOfMonth,
                        },
                        {
                          aDataOra_gte: startOfMonth,
                          aDataOra_lte: endOfMonth,
                        },
                        {
                          daDataOra_lte: startOfMonth,
                          aDataOra_gte: endOfMonth,
                        },
                      ],
                    },
                  },
                },
                {
                  query: azioni,
                  variables: {
                    limit: 200,
                    where: {
                      AND: [
                        {
                          tipoAzioneId: 1,
                        },
                        {
                          OR: [
                            {
                              appuntamentoDaDataOra_gte: startOfDay,
                              appuntamentoDaDataOra_lte: endOfDay,
                            },
                            {
                              appuntamentoADataOra_gte: startOfDay,
                              appuntamentoADataOra_lte: endOfDay,
                            },
                            {
                              appuntamentoDaDataOra_lte: startOfDay,
                              appuntamentoADataOra_gte: endOfDay,
                            },
                          ],
                        },
                      ],
                    },
                  },
                },
              ],
            })
            .then(({ data }) => {
              //console.log(data)
              onCloseModal();
            })
            .catch((error) => {
              console.log(error.message);
              onSetErrorMessage(error.message);
            });
        }
      }
    }

    // HOME - SOLO SEGRETARIA
    else if (eventsType === "home-segretaria") {
      // AGGIORNA (MODIFICA) APPUNTAMENTO
      this.props
        .updateAzione({
          variables: {
            id: values.id,
            azione: {
              clienteId: values.clienteId,
              dataOra: moment().format("YYYY-MM-DD HH:mm"), //DA CONTROLLARE CHE NON LA IMPOSTI GIA' IL SERVER
              tipoAzioneId: 1, //appuntamento
              appuntamentoAgenteId: values.agenteId,
              appuntamentoDaDataOra: moment(values.start).format(
                "YYYY-MM-DD HH:mm"
              ),
              appuntamentoADataOra: moment(values.end).format(
                "YYYY-MM-DD HH:mm"
              ),
              appuntamentoLuogo: values.luogo,
              appuntamentoStato: values.stato,
              appuntamentoOrigine: values.appuntamentoOrigine,
              descrizione: values.descrizione,
            },
          },
          refetchQueries: [
            {
              query: appuntamentiPerStato,
              variables: {
                limit: 100,
                stato: "FISSATO_AGENTE",
                daData: moment().subtract(10, "days").format("YYYY-MM-DD"),
                aData: moment().add(100, "days").format("YYYY-MM-DD"),
              },
            },
            {
              query: appuntamentiPerStato,
              variables: {
                limit: 100,
                stato: "CONFERMATO_SEGRETARIA",
                daData: moment().format("YYYY-MM-DD"),
                aData: moment().add(10, "days").format("YYYY-MM-DD"),
              },
            },
          ],
        })
        .then(({ data }) => {
          //console.log(data)
          onCloseModal();
        })
        .catch((error) => {
          console.log(error.message);
          onSetErrorMessage(error.message);
        });
    }
  };

  isValidDate = (date) => {
    const momentDate = moment(date, "YYYY-MM-DD HH:mm", true);
    return momentDate.isValid();
  };

  validate = (values) => {
    const { eventsType } = this.props;

    const errors = {};

    if (!values.tipoEvento) {
      errors.tipoEvento = "Richiesto";
    }

    // VALIDATION CALENDARIO E CALENDARIO DETT. AGENTE
    if (eventsType === "calendar" || eventsType === "calendar-agent-detail") {
      if (!values.start || !this.isValidDate(values.start)) {
        errors.start = "Richiesto";
      }
      if (!values.end || !this.isValidDate(values.end)) {
        errors.end = "Richiesto";
      }

      // EVENTI DI TIPO APPUNTAMENTO
      if (
        values.tipoEvento &&
        values.tipoEvento.toLowerCase() === "appuntamento"
      ) {
        if (!values.clienteId) {
          errors.clienteId = "Richiesto";
        }
        if (!values.luogo) {
          errors.luogo = "Richiesto";
        }
        if (!values.stato) {
          errors.stato = "Richiesto";
        }

        if (!values.appuntamentoOrigine) {
          errors.stato = "Richiesto";
        }
      }
    }
    // VALIDATION SOLO CALENDARIO
    else if (eventsType === "calendar") {
      if (!values.agenteId) {
        errors.agenteId = "Richiesto";
      }
    }
    // VALIDATION TIMELINE
    else if (eventsType === "timeline") {
      // ALTRE AZIONI (EMAIL E TELEFONATE IN E OUT)
      if (
        values.tipoEvento &&
        values.tipoEvento.toLowerCase() !== "appuntamento"
      ) {
        if (!values.nonRisposto && !values.descrizione) {
          errors.descrizione = "Richiesto";
        }
        if (!values.dataOra || !this.isValidDate(values.dataOra)) {
          errors.dataOra = "Richiesto";
        }
      }

      // AZIONI DI TIPO APPUNTAMENTO
      if (
        values.tipoEvento &&
        values.tipoEvento.toLowerCase() === "appuntamento"
      ) {
        if (!values.agenteId) {
          errors.agenteId = "Richiesto"; // DA CONTROLLARE!!!
        }
        if (!values.start || !this.isValidDate(values.start)) {
          errors.start = "Richiesto";
        }
        if (!values.end || !this.isValidDate(values.end)) {
          errors.end = "Richiesto";
        }
        if (!values.luogo) {
          errors.luogo = "Richiesto";
        }
        if (!values.stato) {
          errors.stato = "Richiesto";
        }
        if (!values.appuntamentoOrigine) {
          errors.appuntamentoOrigine = "Richiesto";
        }
      }
    }
    // VALIDATION HOME SEGRETARIA
    else if (eventsType === "home-segretaria") {
      if (!values.agenteId) {
        errors.agenteId = "Richiesto"; // DA CONTROLLARE!!!
      }
      if (!values.clienteId) {
        errors.clienteId = "Richiesto";
      }
      if (!values.start || !this.isValidDate(values.start)) {
        errors.start = "Richiesto";
      }
      if (!values.end || !this.isValidDate(values.end)) {
        errors.end = "Richiesto";
      }
      if (!values.luogo) {
        errors.luogo = "Richiesto";
      }
      if (!values.stato) {
        errors.stato = "Richiesto";
      }
      if (!values.appuntamentoOrigine) {
        errors.appuntamentoOrigine = "Richiesto";
      }
    }

    return errors;
  };

  render() {
    const {
      classes,
      eventsType,
      initialValues,
      isNewEvent,
      open,
      onCloseModal,
      isAgente,
      isMyCalendar,
      canCreateForm,
    } = this.props;

    return (
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={open}
        onClose={onCloseModal}
        disableBackdropClick={true}
      >
        <div className={classes.modal}>
          <div className={classes.modalHeader}>
            <h3 className={classes.modalTitle}>
              {eventsType === "calendar" ||
              eventsType === "calendar-agent-detail"
                ? initialValues.title || "Aggiungi evento"
                : initialValues.title || "Aggiungi azione"}
                {initialValues.clienteId ? <span><Link to={`/clienti/${initialValues.clienteId}`} target="_blank"><OpenInNew/></Link></span> : ''}
            </h3>
            <span className={classes.modalCloseButton} onClick={onCloseModal}>
              <span className={classes.modalClose}>&times;</span>
            </span>
          </div>
          <Form
            onSubmit={this.onSubmit}
            initialValues={initialValues}
            validate={this.validate}
            render={({
              handleSubmit,
              reset,
              submitting,
              pristine,
              values,
              form,
            }) => (
              <form onSubmit={handleSubmit}>
                <div className={classes.modalBody}>
                  {/* START & END - CALENDARIO E CALENDARIO AGENTI (TIPO APPUNTAMENTO O ASSENZA) */}
                  {(eventsType === "calendar" ||
                    eventsType === "calendar-agent-detail") && (
                    <div>
                      <GridContainer>
                        <ItemGrid xs={6}>
                          <InputLabel className={classes.label}>
                            Inizio
                          </InputLabel>
                          <br />
                          <FormControl fullWidth>
                            <Field
                              name="start"
                              type="text"
                              margin="normal"
                              fullWidth
                              render={({ input, meta }) => (
                                <div>
                                  <Datetime
                                    {...input}
                                    onChange={(v) => {
                                      input.onChange(v);
                                      form.change(
                                        "end",
                                        moment(v, "YYYY-MM-DD HH:mm", true).add(
                                          1,
                                          "hour"
                                        )
                                      );
                                    }}
                                    dateFormat="DD/MM/YYYY"
                                  />
                                  {meta.touched && meta.error && (
                                    <span className={classes.metaError}>
                                      {meta.error}
                                    </span>
                                  )}
                                </div>
                              )}
                            />
                          </FormControl>
                        </ItemGrid>
                        <ItemGrid xs={6}>
                          <InputLabel className={classes.label}>
                            Fine
                          </InputLabel>
                          <br />
                          <FormControl fullWidth>
                            <Field
                              name="end"
                              type="text"
                              margin="normal"
                              fullWidth
                              render={({ input, meta }) => (
                                <div>
                                  <Datetime
                                    {...input}
                                    dateFormat="DD/MM/YYYY"
                                    className="right-date-time-picker"
                                  />
                                  {meta.touched && meta.error && (
                                    <span className={classes.metaError}>
                                      {meta.error}
                                    </span>
                                  )}
                                </div>
                              )}
                            />
                          </FormControl>
                        </ItemGrid>
                      </GridContainer>
                      <br />
                    </div>
                  )}

                  {/* TIPO EVENTO - TUTTI */}
                  <Field
                    name="tipoEvento"
                    label={
                      eventsType === "calendar" ||
                      eventsType === "calendar-agent-detail"
                        ? "Tipo evento"
                        : "Tipo azione"
                    }
                    margin="normal"
                    select
                    fullWidth
                    component={TextField}
                    className={classes.modalSelect}
                    disabled={
                      eventsType === "home-segretaria" ||
                      (eventsType === "calendar" && !!isAgente && !isMyCalendar)
                    }
                    options={
                      eventsType === "calendar" ||
                      eventsType === "calendar-agent-detail"
                        ? [
                            { value: "", label: "-- Seleziona --" },
                            { value: "appuntamento", label: "Appuntamento" },
                            {
                              value: "assenza-occupato",
                              label: "Assenza (occupato)",
                            },
                            {
                              value: "assenza-fuori-sede",
                              label: "Assenza (lavoro fuori sede)",
                            },
                          ]
                        : [
                            { value: "", label: "-- Seleziona --" },
                            { value: "appuntamento", label: "Appuntamento" },
                            {
                              value: "telefonata in",
                              label: "Telefonata in entrata",
                            },
                            {
                              value: "telefonata out",
                              label: "Telefonata in uscita",
                            },
                            { value: "email in", label: "Email in entrata" },
                            { value: "email out", label: "Email in uscita" },
                            {
                              value: "whatsapp in",
                              label: "Whatsapp in entrata",
                            },
                            {
                              value: "whatsapp out",
                              label: "Whatsapp in uscita",
                            },
                            {
                              value: "form",
                              label: "Form",
                              disabled: !canCreateForm,
                              hidden: !canCreateForm,
                            },
                            { value: "promemoria", label: "Promemoria" },
                            { value: "nota", label: "Nota" },
                            {
                              value: "proposta acquisto",
                              label: "Proposta d'acquisto",
                            },
                            { value: "preliminare", label: "Preliminare" },
                          ]
                    }
                  />

                  {/* NON RISPOSTO - TIMELINE; SOLO SE TIPO TEL OUT */}
                  {eventsType === "timeline" &&
                    values.tipoEvento === "telefonata out" && (
                      <label
                        style={{
                          display: "block",
                          margin: "25px 0 15px",
                          color: "#6a7168",
                        }}
                      >
                        <Field
                          name="nonRisposto"
                          component="input"
                          type="checkbox"
                        />
                        Non ha risposto
                      </label>
                    )}

                  {/* CAMPAGNE - TIMELINE; SOLO SE TIPO TEL IN, EMAIL IN O FORM */}
                  {eventsType === "timeline" &&
                    (values.tipoEvento === "telefonata in" ||
                      values.tipoEvento === "email in" ||
                      values.tipoEvento === "whatsapp in" ||
                      values.tipoEvento === "form") && (
                      <Query
                        query={campagne}
                        variables={{
                          limit: 4,
                          orderBy: ["nome_ASC"],
                          where: {
                            OR: [
                              {
                                nome_contains:
                                  this.state.campagneSearchQuery ||
                                  "az1az1az1az1az1az1",
                              },
                              { id: values.campagnaId || null },
                            ],
                          },
                        }}
                      >
                        {({ loading, error, data }) => {
                          return (
                            <Field
                              name="campagnaId"
                              label="Provenienza"
                              margin="normal"
                              fullWidth
                              component={TextField}
                              placeholder=""
                              InputProps={{
                                inputComponent: AutocompleteField,
                                inputProps: {
                                  simpleValue: true,
                                  options:
                                    data && data.campagne
                                      ? data.campagne.nodes.map((campagna) => ({
                                          value: campagna.id,
                                          label: campagna.nome,
                                        }))
                                      : [],
                                  onInputChange:
                                    this.handleChangeCampagneSearchQuery,
                                },
                              }}
                            />
                          );
                        }}
                      </Query>
                    )}

                  {/* OFFERTE - TIMELINE; SOLO SE TIPO TEL IN O EMAIL IN O FORM */}
                  {eventsType === "timeline" &&
                    (values.tipoEvento === "telefonata in" ||
                      values.tipoEvento === "email in" ||
                      values.tipoEvento === "whatsapp in" ||
                      values.tipoEvento === "form") && (
                      <Query
                        query={offerte}
                        variables={{
                          limit: 4,
                          orderBy: ["nome_ASC"],
                          where: {
                            OR: [
                              {
                                nome_contains:
                                  this.state.offerteSearchQuery ||
                                  "az1az1az1az1az1az1",
                              },
                              { id: values.offertaId || null },
                            ],
                          },
                        }}
                      >
                        {({ loading, error, data }) => {
                          return (
                            <Field
                              name="offertaId"
                              label="Offerta"
                              margin="normal"
                              fullWidth
                              component={TextField}
                              placeholder=""
                              InputProps={{
                                inputComponent: AutocompleteField,
                                inputProps: {
                                  simpleValue: true,
                                  options:
                                    data && data.offerte
                                      ? data.offerte.nodes.map((offerta) => ({
                                          value: offerta.id,
                                          label: offerta.nome,
                                        }))
                                      : [],
                                  onInputChange:
                                    this.handleChangeOfferteSearchQuery,
                                },
                              }}
                            />
                          );
                        }}
                      </Query>
                    )}

                  {/* CLIENTI - CALENDARIO, CALENDARIO AGENTI E HOME SEGRETARIA; SOLO SE TIPO APPUNTAMENTO */}
                  {(eventsType === "calendar" ||
                    eventsType === "calendar-agent-detail" ||
                    eventsType === "home-segretaria") &&
                    values.tipoEvento === "appuntamento" && (
                      <Query
                          query={clienti}
                          variables={{
                            limit: 4,
                            where: {
                              OR: [
                                {
                                  nome_contains: this.state.clientiSearchQuery ||
                                    "az1az1az1az1az1az1",
                                },
                                { id: values.clienteId || null },
                              ],
                            },
                          }}
                        >
                          {({ loading, error, data }) => {
                            // if (loading) return <p>Loading...</p>
                            // if (error) return <p>Error :(</p>
                            return (
                              <Field
                                name="clienteId"
                                label="Cliente"
                                margin="normal"
                                fullWidth
                                component={TextField}
                                placeholder=""
                                InputProps={{
                                  inputComponent: AutocompleteField,
                                  inputProps: {
                                    simpleValue: true,
                                    options: data && data.clienti
                                      ? data.clienti.nodes.map((cliente) => ({
                                        value: cliente.id,
                                        label: cliente.nome,
                                      }))
                                      : [],
                                    onInputChange: this.handleChangeClientiSearchQuery,
                                  },
                                }} />
                            );
                          } }
                        </Query>)}

                  {/* AGENTI - CALENDARIO, TIMELINE E HOME SEGRETARIA; SOLO SE TIPO APPUNTAMENTO, PROPOSTA D'ACQUISTO O PRELIMINARE */}
                  {(eventsType === "calendar" ||
                    eventsType === "timeline" ||
                    eventsType === "home-segretaria") &&
                    (values.tipoEvento === "appuntamento" ||
                      values.tipoEvento === "proposta acquisto" ||
                      values.tipoEvento === "preliminare") && (
                      <Query
                        query={agenti}
                        variables={{
                          limit: 50,
                        }}
                      >
                        {({ loading, error, data }) => {
                          if (loading) return <p>Loading...</p>;
                          if (error) return <p>Error :(</p>;

                          return (
                            <Field
                              name="agenteId"
                              label="Agente"
                              margin="normal"
                              select
                              fullWidth
                              component={TextField}
                              className={classes.modalSelect}
                              // disabled={
                              //   eventsType === 'calendar' && values.tipoEvento === 'appuntamento'
                              // }
                              options={data.utenti.nodes.map((agente) => ({
                                value: agente.id,
                                label: agente.nome,
                              }))} />
                          );
                          } }
                      </Query>
                    )}

                  {/* START & END - TIMELINE E HOME SEGRETARIA; SOLO SE TIPO APPUNTAMENTO */}
                  {(eventsType === "timeline" ||
                    eventsType === "home-segretaria") &&
                    values.tipoEvento === "appuntamento" && (
                      <div>
                        <br />
                        <GridContainer>
                          <ItemGrid xs={6}>
                            <InputLabel className={classes.label}>
                              Inizio
                            </InputLabel>
                            <br />
                            <FormControl fullWidth>
                              <Field
                                name="start"
                                type="text"
                                margin="normal"
                                fullWidth
                                render={({ input, meta }) => (
                                  <div>
                                    <Datetime
                                      {...input}
                                      onChange={(v) => {
                                        input.onChange(v);
                                        form.change(
                                          "end",
                                          moment(
                                            v,
                                            "YYYY-MM-DD HH:mm",
                                            true
                                          ).add(1, "hour")
                                        );
                                      }}
                                      dateFormat="DD/MM/YYYY"
                                    />
                                    {meta.touched && meta.error && (
                                      <span className={classes.metaError}>
                                        {meta.error}
                                      </span>
                                    )}
                                  </div>
                                )}
                              />
                            </FormControl>
                          </ItemGrid>
                          <ItemGrid xs={6}>
                            <InputLabel className={classes.label}>
                              Fine
                            </InputLabel>
                            <br />
                            <FormControl fullWidth>
                              <Field
                                name="end"
                                type="text"
                                margin="normal"
                                fullWidth
                                render={({ input, meta }) => (
                                  <div>
                                    <Datetime
                                      {...input}
                                      dateFormat="DD/MM/YYYY"
                                      className="right-date-time-picker"
                                    />
                                    {meta.touched && meta.error && (
                                      <span className={classes.metaError}>
                                        {meta.error}
                                      </span>
                                    )}
                                  </div>
                                )}
                              />
                            </FormControl>
                          </ItemGrid>
                        </GridContainer>
                      </div>
                    )}

                  {/* LUOGO E STATO APPUNTAMENTO - TUTTI; SOLO SE TIPO APPUNTAMENTO */}
                  {values.tipoEvento === "appuntamento" && (
                    <div>
                      <Field
                        name="luogo"
                        label="Luogo di incontro"
                        type="text"
                        margin="normal"
                        fullWidth
                        component={TextField}
                      />
                      <Field
                        name="stato"
                        label="Stato"
                        margin="normal"
                        select
                        fullWidth
                        component={TextField}
                        className={classes.modalSelect}
                        options={[
                          { value: "", label: "-- Seleziona --" },
                          { value: "FISSATO_AGENTE", label: "Fissato agente" },
                          {
                            value: "CONFERMATO_SEGRETARIA",
                            label: "Confermato segretaria",
                          },
                          {
                            value: "CONFERMATO_CLIENTE",
                            label: "Confermato cliente",
                          },
                          {
                            value: "ANNULLATO_CLIENTE",
                            label: "Disdetto cliente",
                          },
                          { value: "SALTATO", label: "Saltato" },
                          { value: "FATTO", label: "Fatto" },
                        ]}
                      />
                      <Field
                        name="appuntamentoOrigine"
                        label="Origine"
                        margin="normal"
                        select
                        fullWidth
                        component={TextField}
                        className={classes.modalSelect}
                        options={[
                          { value: "", label: "-- Seleziona --" },
                          {
                            value: "Fissato da agente",
                            label: "Fissato da agente",
                          },
                          { value: "SMS", label: "SMS" },
                          { value: "DEM", label: "DEM" },
                        ]}
                      />
                    </div>
                  )}

                  {/* PROMEMORIA UTENTE ID - TIMELINE; SOLO SE TIPO PROMEMORIA */}
                  {eventsType === "timeline" &&
                    values.tipoEvento === "promemoria" && (
                      <Query
                        query={agentiSegretarie}
                        variables={{
                          limit: 50,
                        }}
                      >
                        {({ loading, error, data }) => {
                          if (loading) return <p>Loading...</p>;
                          if (error) return <p>Error :(</p>;

                          return (
                            <Field
                              name="promemoriaUtenteId"
                              label="Agente o segretaria"
                              margin="normal"
                              select
                              fullWidth
                              component={TextField}
                              className={classes.modalSelect}
                              options={data.utenti.nodes.map(
                                (agenteSegretaria) => ({
                                  value: agenteSegretaria.id,
                                  label: agenteSegretaria.nome,
                                })
                              )}
                            />
                          );
                        }}
                      </Query>
                    )}

                  {/* DESCRIZIONE - TUTTI */}
                  {!(
                    eventsType === "timeline" &&
                    values.tipoEvento === "telefonata out" &&
                    values.nonRisposto
                  ) && (
                    <Field
                      name="descrizione"
                      label="Descrizione"
                      type="text"
                      margin="normal"
                      fullWidth
                      multiline
                      rows="4"
                      component={TextField}
                    />
                  )}

                  {/* PROMEMORIA DATA ORA - TIMELINE; SOLO SE TIPO PROMEMORIA */}
                  {eventsType === "timeline" &&
                    values.tipoEvento === "promemoria" && (
                      <div>
                        <br />
                        <InputLabel className={classes.label}>
                          Data e ora promemoria
                        </InputLabel>
                        <br />
                        <FormControl fullWidth>
                          <Field
                            name="promemoriaDataOra"
                            type="text"
                            margin="normal"
                            fullWidth
                            render={({ input, meta }) => (
                              <div>
                                <Datetime
                                  {...input}
                                  dateFormat="DD/MM/YYYY"
                                  className="top-date-time-picker"
                                />
                                {meta.touched && meta.error && (
                                  <span className={classes.metaError}>
                                    {meta.error}
                                  </span>
                                )}
                              </div>
                            )}
                          />
                        </FormControl>
                      </div>
                    )}

                  {/* DATA ORA - TIMELINE; SOLO SE TIPO DIVERSO DA APPUNTAMENTO O PROMEMORIA */}
                  {eventsType === "timeline" &&
                    values.tipoEvento !== "" &&
                    values.tipoEvento !== "appuntamento" &&
                    values.tipoEvento !== "promemoria" && (
                      <div>
                        <br />
                        <InputLabel className={classes.label}>
                          Data e ora
                        </InputLabel>
                        <br />
                        <FormControl fullWidth>
                          <Field
                            name="dataOra"
                            type="text"
                            margin="normal"
                            fullWidth
                            render={({ input, meta }) => (
                              <div>
                                <Datetime
                                  {...input}
                                  dateFormat="DD/MM/YYYY"
                                  className="top-date-time-picker"
                                />
                                {meta.touched && meta.error && (
                                  <span className={classes.metaError}>
                                    {meta.error}
                                  </span>
                                )}
                              </div>
                            )}
                          />
                        </FormControl>
                      </div>
                    )}
                </div>

                <div className={classes.modalFooter}>
                  <div className="buttons">
                    {!isNewEvent && (
                      <IconButton
                        className={classes.modalSmallFooterDeleteButton}
                        color="secondary"
                        tabIndex="-1"
                        onClick={this.deleteEvent(
                          initialValues.id,
                          initialValues.tipoEvento,
                          initialValues.agenteId
                        )}
                      >
                        <Delete />
                      </IconButton>
                    )}
                    <Button
                      className={classes.modalSmallFooterFirstButton}
                      type="submit"
                      disabled={submitting}
                      variant="raised"
                      color="primary"
                    >
                      {!!isNewEvent ? "Crea" : "Salva modifiche"}
                    </Button>
                    <Button
                      className={classes.modalSmallFooterSecondButton}
                      onClick={onCloseModal}
                    >
                      Chiudi
                    </Button>
                  </div>
                </div>
              </form>
            )}
          />
        </div>
      </Modal>
    );
  }
}

export default compose(
  withStyles(modalStyle),
  graphql(createAssenza, { name: "createAssenza" }),
  graphql(createAzione, { name: "createAzione" }),
  graphql(updateAssenza, { name: "updateAssenza" }),
  graphql(updateAzione, { name: "updateAzione" }),
  graphql(deleteAssenza, { name: "deleteAssenza" }),
  graphql(deleteAzione, { name: "deleteAzione" })
)(CalendarModalForm);



// WEBPACK FOOTER //
// ./src/components/CalendarModalForm/CalendarModalForm.jsx